<button
    class="unavailable-modal__close"
    type="button"
    (click)="close()"
>
  <icon
      height="16px"
      width="16px"
      [src]="'./assets/img/icons/close.svg'"
  />
</button>

<div class="unavailable-modal__icon-wrapper">
  <icon
    height="120px"
    width="150px"
    [src]="'./assets/img/icons/i-tools.svg'"
  />
</div>

<div class="unavailable-modal__content margin-card">
  <div class="h2 unavailable-modal__title">
    {{ titleKey | translate }}
  </div>

  <p class="unavailable-modal__description">
    {{ descriptionKey | translate: descriptionParams }}
  </p>
</div>

<div class="unavailable-modal__actions">
  <button
    class="button-border"
    type="button"
    (click)="confirm()"
  >
    {{ buttonKey | translate }}
  </button>
</div>
